import { MicroMClient, MicromUsers } from "@mcurros2/microm";

export class CustomMicromUsers extends MicromUsers {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.Title = "Usuarios";
        this.def.columns.c_user_id.prompt = "ID";
        this.def.columns.c_user_id.description = "El usuario ID es generado automáticamente por el sistema";
        this.def.columns.vc_username.prompt = "Nombre de usuario";
        this.def.columns.vc_username.description = "El nombre de usuario con el que iniciará sesión. Puede ser un correo electrónico.";
        this.def.columns.bt_disabled.prompt = "Usuario deshabilitado";
        this.def.columns.bt_disabled.description = "Un usuario deshabilitado no puede inciar sesión. Puede tomar 20 minutos para que haga efecto si el usuario se encuentra conectado.";
        this.def.columns.dt_last_login.prompt = "Último inicio de sesión";
        this.def.columns.dt_last_login.description = "Este valor se actualiza al iniciar sesión, no indica si el usuario se encuentra conectado actualmente.";
        this.def.columns.c_usertype_id.prompt = "Tipo de Usuario";
        this.def.columns.c_usertype_id.description = "El Tipo de Usuario indica a qué sistemas puede acceder y el grupo al que pertenece el usuario, sobre el cuál se aplicarán permisos.";
        this.def.columns.i_badlogonattempts.prompt = "Intentos fallidos";
        this.def.columns.i_badlogonattempts.description = "Indica el número de Intentos fallidos para iniciar sesión. Superado el máximo permitido la cuenta se bloqueará automáticamente por un periodo de tiempo.";

        this.def.columns.vc_email.description = "El campo de Email es opcional. Sin embargo, si este campo no está completo esta cuenta de usuario NO PODRÁ RECUPERAR SU CLAVE.";

    }
}